var o="1.35.0";export{o as a};
//# sourceMappingURL=chunk-BY3XFRUM.mjs.map